<template>
  <div class="basket-group loader-container">
    <h3>{{ basketItemProductGroup.productName }}</h3>
    <BasketItemGroup
      v-for="basketItemGroup in basketItemProductGroup.itemGroups"
      :key="basketItemGroup.id"
      :basket-item-group="basketItemGroup"
      :product-type="basketItemProductGroup.product.type"
    />
    <div>
      <button
        class="ui-button"
        type="button"
        @click="editBasketItemProductGroup"
      >
        Edit
      </button>
      <button
        class="ui-button"
        type="button"
        @click="deleteBasketItemProductGroup"
      >
        Delete
      </button>
    </div>
    <Loader :loading="processing" />
  </div>
</template>
<script>
import Service from '@/services/Service.js';
import Loader from '@/components/Loader.vue';
import BasketItemGroup from '@/components/BasketItemGroup.vue';
export default {
  components: { BasketItemGroup, Loader },
  props: {
    basketItemProductGroup: { type: Object, default: null }
  },
  data: function() {
    return {
      processing: false
    };
  },
  methods: {
    editBasketItemProductGroup() {
      this.$router.push({
        name: 'product',
        params: {
          showId: this.basketItemProductGroup.showId,
          performanceId: this.basketItemProductGroup.performanceId,
          productId: this.basketItemProductGroup.productId
        }
      });
    },
    deleteBasketItemProductGroup() {
      this.processing = true;
      var basketItemGroups = [];
      this.basketItemProductGroup.itemGroups.forEach(basketItemGroup => {
        basketItemGroup.quantity = 0;
        basketItemGroups.push(basketItemGroup);
      });
      var basketRequest = {};
      basketRequest.itemGroups = basketItemGroups;
      Service.addToBasket(basketRequest)
        .then(() => {
          this.$store
            .dispatch('loadBasket')
            .then(() => {
              this.processing = false;
              this.$store.dispatch('addMessage', {
                message: 'Basket Updated',
                timeout: 3000
              });
            })
            .catch(error => {
              this.processing = false;
              this.$store.dispatch('addMessage', {
                message: 'Error loading basket'
              });
              console.log(error);
            });
        })
        .catch(error => {
          this.$store.dispatch('addMessage', {
            message: 'Error Deleting Items',
            timeout: 3000
          });
          this.processing = false;
          console.log(error.response);
        });
    }
  }
};
</script>
